/* eslint no-unused-vars: [2, { "varsIgnorePattern": "MediaTypes|MimeTypes" }] */
import DataURIConverter from 'utils/DataURIConverter';
import MediaTypes from 'components/shared/media/MediaTypes';
import MimeTypes from 'components/shared/media/MimeTypes';

const MediaTypeContentTypeMap = {
  [MediaTypes.FEED_IMAGE]: MimeTypes.JPEG,
  [MediaTypes.FEED_VIDEO]: MimeTypes.BIN,
  [MediaTypes.PROFILE_IMAGE]: MimeTypes.JPEG,
};

const uploadMediaToS3 = (params) => {
  const { s3Params } = params;

  // see http://docs.aws.amazon.com/AmazonS3/latest/dev/HTTPPOSTForms.html
  const formData = new FormData();
  formData.append('acl', 'public-read');
  formData.append('AWSAccessKeyId', s3Params.awsAccessKeyId);
  formData.append('Content-Type', params.contentType);
  formData.append('mediaType', params.mediaType);
  formData.append('key', s3Params.key);
  formData.append('policy', s3Params.policy);
  formData.append('signature', s3Params.signature);
  formData.append('file', params.file);

  return new Promise((resolve, reject) => {
    $.ajax({
      url: s3Params.url,
      data: formData,
      processData: false,
      contentType: false,
      type: 'POST',
      success(data, status, xhr) {
        resolve({ data, status, xhr });
      },
      error(request) {
        const error = new Error(request.responseText);
        error.status = request.status;
        reject(error);
      },
    });
  });
};

const uploadMediaFileToS3 = params => new Promise((resolve) => {
  resolve(uploadMediaToS3({
    ...params,
    contentType: MediaTypeContentTypeMap[params.mediaType],
  }));
});

const uploadMediaURIToS3 = params => new Promise((resolve) => {
  const newParams = {
    ...params,
    contentType: MediaTypeContentTypeMap[params.mediaType],
  };
  DataURIConverter.getBlobFromDataURI(newParams.dataURI, newParams.contentType).then((fileBlob) => {
    newParams.file = fileBlob;
    resolve(uploadMediaToS3(newParams));
  });
});

export default { uploadMediaFileToS3, uploadMediaURIToS3, MediaTypeContentTypeMap };
